import React, { useEffect, useState, useRef, createElement } from 'react';
export const CalendlyEmbed = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const scriptRef = useRef<HTMLScriptElement | null>(null);
  useEffect(() => {
    const loadFormScript = async () => {
      try {
        if (!scriptRef.current) {
          const script = document.createElement('script');
          script.src = 'https://admin.thehireadvantage.co/js/form_embed.js';
          script.async = true;
          script.onload = () => {
            setIsLoading(false);
          };
          script.onerror = () => {
            console.error('Failed to load form embed script');
            setHasError(true);
            setIsLoading(false);
          };
          scriptRef.current = script;
          document.head.appendChild(script);
        }
      } catch (error) {
        console.error('Error loading form script:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    loadFormScript();
    return () => {
      if (scriptRef.current && document.head.contains(scriptRef.current)) {
        document.head.removeChild(scriptRef.current);
      }
    };
  }, []);
  // Add URL parameters to iframe for ad tracking
  useEffect(() => {
    const addUrlParamsToIframe = () => {
      const iframe = document.getElementById('GDgnFdc1ENo3L8xJqNC4') as HTMLIFrameElement;
      if (iframe) {
        const params = window.location.search;
        if (params) {
          const separator = iframe.src.indexOf('?') === -1 ? '?' : '&';
          iframe.src = iframe.src + separator + params.substring(1);
        }
      }
    };
    // Run on window load
    if (document.readyState === 'complete') {
      addUrlParamsToIframe();
    } else {
      window.addEventListener('load', addUrlParamsToIframe);
      return () => window.removeEventListener('load', addUrlParamsToIframe);
    }
  }, []);
  if (hasError) {
    return <div className="w-full max-w-6xl mx-auto mb-10 sm:mb-16" data-id="element-34">
        <div className="rounded-xl overflow-hidden shadow-lg bg-white p-8" data-id="element-35">
          <p className="text-gray-800 text-center" data-id="element-36">
            Unable to load application form. Please refresh the page or try
            again later.
          </p>
        </div>
      </div>;
  }
  return <div className="w-full max-w-6xl mx-auto mb-10 sm:mb-16" data-id="element-37">
      <div className="rounded-xl overflow-hidden shadow-lg relative bg-white" data-id="element-38">
        <div className="relative" style={{
        minHeight: '600px'
      }} data-id="element-39">
          <iframe ref={iframeRef} src="https://admin.thehireadvantage.co/widget/survey/GDgnFdc1ENo3L8xJqNC4" style={{
          border: 'none',
          width: '100%',
          minHeight: '600px'
        }} scrolling="no" id="GDgnFdc1ENo3L8xJqNC4" title="survey" onLoad={() => setIsLoading(false)} onError={() => {
          setHasError(true);
          setIsLoading(false);
        }} data-id="element-40" />
        </div>
        {isLoading && <div className="absolute inset-0 bg-white/90 backdrop-blur-sm flex items-center justify-center" data-id="element-41">
            <div className="flex flex-col items-center gap-4" data-id="element-42">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent" data-id="element-43" />
              <p className="text-gray-800 text-sm" data-id="element-44">
                Loading application form...
              </p>
            </div>
          </div>}
      </div>
    </div>;
};